import { render, staticRenderFns } from "./CenterOrbs.vue?vue&type=template&id=03daee63"
import script from "./CenterOrbs.vue?vue&type=script&lang=js"
export * from "./CenterOrbs.vue?vue&type=script&lang=js"
import style0 from "./CenterOrbs.vue?vue&type=style&index=0&id=03daee63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports